import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Row } from 'react-bootstrap';

import BuildSelectorContainer from './../Containers/BuildSelectorContainer';

const BuildSelectorModalComponent = ({
  visible,
  isBaseline,
  onHide
}) => (
  <Modal show={visible} onHide={onHide} bsSize="lg">
    <Modal.Header closeButton>
      <Modal.Title>Select Case Metrics Baseline Build</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Row>
        <BuildSelectorContainer isBaseline={isBaseline} />
      </Row>
    </Modal.Body>
  </Modal>
);

BuildSelectorModalComponent.propTypes = {
  visible: PropTypes.bool,
  isBaseline: PropTypes.bool,
  onHide: PropTypes.func.isRequired
};

export default BuildSelectorModalComponent;


// WEBPACK FOOTER //
// src/Components/BuildSelectorModalComponent.jsx